<template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              {{ form.id ? 'Update Barangay' : 'Create New Barangay' }}
            </h4>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label>Code (3 letters only)</label>
              <ValidationProvider name="code" rules="required" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'code is required' : null" :hasSuccess="passed"
                  name="name" v-model="form.code">
                </fg-input>
              </ValidationProvider>
            </div>

            <div class="form-group">
              <label>Name</label>
              <ValidationProvider name="name" rules="required" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'name is required' : null" :hasSuccess="passed"
                  name="name" v-model="form.name">
                </fg-input>
              </ValidationProvider>
            </div>
        
          </div>
          <div class="card-footer text-right">
            <p-button type="info" native-type="submit">Save</p-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </template>
  <script>
  import { extend } from "vee-validate";
  import { required } from "vee-validate/dist/rules";
  import { Barangay } from '@/resources/barangay'

  extend("required", required);
  
  export default {
    props: ['barangay'],
    data() {
      return {
        form: {
          name: "",
        },
        loading: false
      };
    },
    watch: {
      voter: function () {
        if (this.barangay) this.form = Object.assign({}, this.barangay)
      }
    },
    created: function () {
      if (this.barangay) this.form = Object.assign({}, this.barangay)
    },
    beforeDestroy() {
      this.form = {
        name: "",
      }
    },
    methods: {
      submit() {  
        this.loading = true
        let request = this.form.id ? Barangay.update(this.form.id, this.form) : Barangay.create(this.form)
  
        request
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Barangay has been saved',
            });
            this.$emit('save', true)
          })
          .catch(error => {
        
          }).finally(() => {
            this.loading = false
          })
      }
    }
  }
  </script>
  <style></style>
  